import { ExperimentData } from '@/types';
import { useUser } from '@/queries/useUser';
import { Experiment, EXPERIMENTS } from '../constants';
import { useEffect } from 'react';

import { useExperimentQueries } from '../queries';

export function useExperiments() {
    const { user } = useUser();
    const {
        assignUserToExperimentsMutation,
        experimentsCommunities,
        isExperimentCommunitiesLoading,
        experimentsCommunityStats,
        isExperimentCommunityStatsLoading,
        experimentsMetadata,
        isExperimentMetadataLoading,
    } = useExperimentQueries();

    const hasExperiment = (experiment?: Experiment) => {
        if (!experiment) return false;
        return !!user?.experiments?.[experiment.dbName];
    };

    // Handles experiment assignment
    useEffect(() => {
        if (!user) return;
        const experimentsToAssign: ExperimentData = {};
        for (const experiment of Object.values(EXPERIMENTS)) {
            // Only auto-assign if experiment has a probability defined
            if (experiment.probability !== undefined && !(experiment.dbName in user.experiments)) {
                experimentsToAssign[experiment.dbName] = Math.random() < experiment.probability ? 1 : 0;
            }
        }
        // Only assign if there are experiments to assign
        if (Object.keys(experimentsToAssign).length > 0) {
            assignUserToExperimentsMutation(experimentsToAssign);
        }
    }, [user]);

    return {
        hasExperiment,
        experimentsCommunities,
        isExperimentCommunitiesLoading,
        experimentsCommunityStats,
        isExperimentCommunityStatsLoading,
        experimentsMetadata,
        isExperimentMetadataLoading,
    };
}
